import {Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {BehaviorSubject, ReplaySubject, Subject} from 'rxjs';
import {BaseSelect2Model} from '../../model/base-select2.model';
import {takeUntil} from 'rxjs/operators';
import {MatSelect} from '@angular/material/select';
import {Select2Service} from '../../services/common/select2.service';

@Component({
  selector: 'app-base-select2',
  templateUrl: './base-select2.component.html',
  styleUrls: ['./base-select2.component.scss']
})
export class BaseSelect2Component implements OnInit {
  @Input() formGroupParent: FormGroup;
  @Input() formName: string;
  @Input() labelName: string;
  @Input() selectedVal: string;
  @Input() mandatory: boolean;
  @Input() disabledBol: boolean;
  @Output() valueChange = new EventEmitter();
  @Output() getDataChange = new EventEmitter();

  loading$ = new BehaviorSubject<boolean>(false);
  testEmitter$ = new BehaviorSubject<any>(false);


  filterCtrl: FormControl = new FormControl();

  filtered: ReplaySubject<BaseSelect2Model[]> = new ReplaySubject<
    BaseSelect2Model[]
    >(1);

  private data: BaseSelect2Model[] = [];

  @ViewChild("singleSelect", { static: true }) singleSelect: MatSelect;

  protected _onDestroy = new Subject<void>();

  constructor(
    protected commonService: Select2Service,
    @Inject("") public label: string
  ) {}

  get labelTitleName() {
    if (this.labelName) {
      return this.labelName;
    } else {
      return this.label;
    }
  }

  ngOnInit() {
    this.listData();
    this.filterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filter();
      });
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  private filter() {
    if (!this.data) {
      return;
    }
    // get the search keyword
    let search = this.filterCtrl.value;
    if (!search) {
      this.filtered.next(this.data.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    // filtering
    this.filtered.next(
      this.data.filter((partner) => {
        if (partner.name) {
          return partner.name.toLowerCase().indexOf(search) > -1;
        }
        return false
      })
    );
  }

  private async listData() {
    this.loading$.next(true);

    try {
        this.data = await this.getData();
    } catch (e) {
        console.log(e, 'error');
    }
    this.getDataChange.emit(this.data);
    await this.filtered.next(this.data);
    await this.loading$.next(false);
    await this.testEmitter$.next(true);
  }

  protected async getData(): Promise<any> {
    return this.data;
  }

  compareObjects(o1: any, o2: any): boolean {
    return o1 == o2;
  }

  emitSomething(event) {
    this.valueChange.emit(event)
  }

  // helpers for View
  isControlValid(controlName: string): boolean {
    const control = this.formGroupParent.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }

  isControlInvalid(controlName: string): boolean {
    const control = this.formGroupParent.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }

  controlHasError(validation, controlName): boolean {
    const control = this.formGroupParent.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }

  isControlTouched(controlName): boolean {
    const control = this.formGroupParent.controls[controlName];
    return control.dirty || control.touched;
  }
}
